import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-recepting',
  templateUrl: './receipting.component.html',
  styleUrls: ['./receipting.component.scss']
})
export class ReceiptingComponent implements OnInit {
  ngOnInit() {
  }
}
